import LangSelector from "./LangSelector.component";

export default LangSelector;
